import { render, staticRenderFns } from "./FinanceTabRefunds.vue?vue&type=template&id=74473e04"
import script from "./FinanceTabRefunds.vue?vue&type=script&lang=js"
export * from "./FinanceTabRefunds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports